<template>
  <div>
    <v-layout wrap justify-center px-12 pt-2>
      <!-- <v-flex style="position:sticky!important" xs12 sm12 md6>
        <v-img
          src="../../assets/g1.jpg"
          width="100%"
          contain
        />
      </v-flex> -->
      <v-flex xs12 sm7 pb-12 class="align-self-center">
        <SellerRegistrationForm />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import SellerRegistrationForm from "./sellerRegistrationForm";
export default {
  components: {
    SellerRegistrationForm,
  },
};
</script>